export default __webpack_public_path__ + "static/media/graph-type-4-cropped.55ce33a3.png";